import { createBox } from '@mui/system';
import { createTheme } from '../styles';
const defaultTheme = createTheme();
/**
 * @ignore - do not document.
 */

const Box = createBox({
  defaultTheme
});
export default Box;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/material/Box/Box.js
// module id = 7426
// module chunks = 0